/**
 * Error Logging Constants
 *
 * Defines which fields are safe to log and which should NEVER be logged
 *
 * @see /docs/ERROR_BOUNDARY_IMPROVEMENTS.md for security guidelines
 */

/**
 * Fields that are SAFE to log
 */
export const SAFE_TO_LOG = {
  // Request metadata
  method: true,
  path: true,
  statusCode: true,
  duration: true,
  timestamp: true,
  correlationId: true,
  requestId: true,

  // Error metadata
  errorCode: true,
  errorType: true,
  errorCategory: true,
  errorSeverity: true,
  translationKey: true,

  // Non-sensitive IDs
  groupId: true,
  expenseId: true,
  activityId: true,
  notificationId: true,
  invitationId: true,

  // Aggregated data
  itemCount: true,
  totalAmount: true,
  currency: true,
  memberCount: true,

  // Browser metadata
  userAgent: true,
  browserName: true,
  osName: true,
  deviceType: true,

  // Performance data
  loadTime: true,
  responseTime: true,
  memoryUsage: true,
} as const;

/**
 * Fields that should NEVER be logged
 * (PII, auth credentials, payment data, system secrets)
 */
export const NEVER_LOG = {
  // Authentication & Authorization
  password: true,
  passwordHash: true,
  refreshToken: true,
  accessToken: true,
  token: true,
  apiKey: true,
  jwt: true,
  sessionId: true,
  authToken: true,
  bearerToken: true,
  oauthToken: true,

  // Personal Identifiable Information (PII)
  email: true,
  phoneNumber: true,
  fullName: true,
  firstName: true,
  lastName: true,
  dateOfBirth: true,
  ssn: true,
  socialSecurityNumber: true,
  address: true,
  zipCode: true,
  postalCode: true,

  // Payment Information
  creditCardNumber: true,
  cardNumber: true,
  cvv: true,
  cvc: true,
  bankAccount: true,
  routingNumber: true,
  iban: true,
  paymentMethod: true,

  // System Secrets
  databaseUrl: true,
  awsSecretKey: true,
  awsAccessKey: true,
  encryptionKey: true,
  privateKey: true,
  secret: true,
  apiSecret: true,
  webhookSecret: true,

  // Sensitive Configuration
  connectionString: true,
  databasePassword: true,
  redisPassword: true,
} as const;

/**
 * Email regex for detection
 */
export const EMAIL_REGEX =
  /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi;

/**
 * Token patterns (JWT, etc.)
 */
export const TOKEN_REGEX =
  /eyJ[a-zA-Z0-9_-]+\.[a-zA-Z0-9_-]+\.[a-zA-Z0-9_-]+/gi;

/**
 * IP address regex
 */
export const IP_REGEX = /\b\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\b/g;

/**
 * Credit card regex (basic detection)
 */
export const CREDIT_CARD_REGEX = /\b\d{4}[\s-]?\d{4}[\s-]?\d{4}[\s-]?\d{4}\b/g;
